import React from 'react';
import PropTypes from 'prop-types';

import themeable from 'zignal-landscape/lib/themeable';
import EditIcon from 'zignal-landscape/lib/Icon/EditIcon';
import TrashIcon from 'zignal-landscape/lib/Icon/TrashIcon';

const ZccListItem = ({
  styles,
  zcc,
  onEditClick,
  onDeleteClick,
  disableMenu = false
}) => {

  const renderMenu = (
    <span className={styles.menu}>
      <a onClick={()=>onEditClick(zcc)} className={styles.edit}><EditIcon /></a>
      <a onClick={()=>onDeleteClick(zcc)} className={styles.trash}><TrashIcon /></a>
    </span>
  );

  return (
    <div className={styles.ZccListItem}>
      <span className={styles.name}>{zcc.name}</span> <span className={styles.id}>{zcc._id}</span>
      {disableMenu ? '' : renderMenu}
    </div>
  );
};

ZccListItem.propTypes = {
  styles: PropTypes.object,
  zcc: PropTypes.object,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  disableMenu: PropTypes.bool
};

export default themeable(ZccListItem);
